import { ThemerIndex } from '@/app/themer/_Index'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_themer/themer/')({
    component: ThemerIndex
})